export var getIsFooterVisibleRoute = function (toState, routes) {
    var _a, _b;
    // eslint-disable-next-line
    for (var _i = 0, routes_1 = routes; _i < routes_1.length; _i++) {
        var route = routes_1[_i];
        if (route.name === toState.name && ((_a = route.actionResult) === null || _a === void 0 ? void 0 : _a.footerVisible)) {
            return (_b = route.actionResult) === null || _b === void 0 ? void 0 : _b.footerVisible;
        }
    }
};
